import { React, useState, useEffect } from 'react';
import PageHeader from 'utility/PageHeader';
import PageBody from 'utility/PageBody';
import { Button, Form, Input, Row, Col, Table, Modal, Image, Select, Upload, Skeleton, Spin } from 'antd';
import { HttpHandler } from '../../shared/httpHandler';
import { EditOutlined, DeleteOutlined, RocketOutlined, PlusOutlined, SearchOutlined, UploadOutlined, SyncOutlined, RedoOutlined } from '@ant-design/icons';
import moment from 'moment';
import dayjs from 'dayjs';
import './RichmenuMaintenance.scss';
import secureStorage from '../../shared/secureStorage';

const httpHandler = new HttpHandler();
const baseURL = process.env.REACT_APP_BASE_URL + '/dashboard/toyota_mgmt' || 'http://localhost:8000/dashboard/toyota_mgmt'
const richmenuTypeMap = {
    0: '全部',
    1: '車主服務-未綁定',
    2: '探索車款-未綁定',
    3: '車主活動-未綁定',
    4: '車主服務-已綁定',
    5: '探索車款-已綁定',
    6: '車主活動-已綁定',
};

const modalMessage = {

}

const RichmenuMaintenance = () => {
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [selectedRow, setSelectedRow] = useState(null);
    const [isSelectedRowPic, setIsSelectedRowPic] = useState(false);
    const [selectedRowPic, setSelectedRowPic] = useState(null);
    const { Option } = Select;
    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams({
            pagination,
            filters,
            ...sorter,
        });
        getTableData(pagination);
    };
    const [editBlockform] = Form.useForm();
    const [searchForm] = Form.useForm();
    const [layoutCount, setLayoutCount] = useState(0);
    const [imageLoading, setImageLoading] = useState(true);
    const [isEditVisible, setIsEditVisible] = useState(false);
    const [submitActionType, setSubmitActionType] = useState('create');
    const [submitFormData, setSubmitFormData] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const [previewVisible, setPreviewVisible] = useState(false);
    const [totalBlockType, setTotalBlockType] = useState({
        "0": "0",
        "1": "0",
        "2": "0",
        "3": "0",
        "4": "0",
        "5": "0",
    });

    const updateBlockType = (key, value) => {
        setTotalBlockType(prevState => ({
            ...prevState,
            [key]: value
        }));
    };

    const getTableData = (pagination = tableParams.pagination) => {
        let { category, name, isCancel } = searchForm.getFieldsValue();
        category = category ?? '';
        name = name ? name.trim() : '';
        isCancel = isCancel ?? "0";
        const { current, pageSize } = pagination;

        setLoading(true);
        httpHandler
            .get(
                `/toyota_mgmt/richmenu_maintenance/get_richmenu_data?name=${name}&category=${category}&is_cancel=${isCancel}&current=${current}&page_size=${pageSize}`
            )
            .then((response) => {
                if (response.success) {
                    setTableData(response.data);
                    setTableParams({
                        ...tableParams,
                        pagination: {
                            ...pagination,
                            total: response.total,
                        },
                    });
                } else {
                    window.antdNotify('錯誤', response.message, 'fail');
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const searchRichmenuData = async () => {
        setTableParams({
            ...tableParams,
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
        getTableData({
            current: 1,
            pageSize: 10,
        });
    }

    useEffect(() => {
        searchRichmenuData();
    }, []);


    const SearchBar = () => {
        return (
            <>
                <Form
                    form={searchForm}
                    name="searchForm"
                    onFinish={searchRichmenuData}
                    initialValues={{ isCancel: 0 }}
                >
                    <Row gutter={16}>
                        <Col span={8}>
                            <Form.Item label="選單名稱" name="name">
                                <Input allowClear />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="選單分類" name="category">
                                <Select>
                                    {Object.keys(richmenuTypeMap).map((key) => (
                                        <Select.Option key={key} value={key}>
                                            {richmenuTypeMap[key]}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="選單狀態" name="isCancel">
                                <Select>
                                    <Option value="">全部</Option>
                                    <Option value={0}>啟用中</Option>
                                    <Option value={1}>非啟用</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={16} className="button-group">
                            <Button
                                type="primary"
                                icon={<RedoOutlined />}
                                onClick={() => {
                                    Modal.confirm({
                                        title: '確認操作',
                                        content: (
                                            <div>
                                                確認重置圖文選單嗎？<br />
                                            </div>
                                        ),
                                        okText: '確認',
                                        cancelText: '取消',
                                        onOk() {
                                            return httpHandler.post(`/toyota_mgmt/richmenu_maintenance/reset_richmenu`).then((response) => {
                                                if (response.data.success) {
                                                    window.antdNotify('重置成功', response.message, 'success');
                                                    searchRichmenuData();
                                                } else {
                                                    window.antdNotify('重置錯誤', response.data.data, 'fail');
                                                }
                                            });
                                        },
                                        onCancel() {
                                            console.log('取消操作');
                                        },
                                    });
                                }}
                                className="button button--delete">
                                重置選單
                            </Button>
                            <Button
                                type="primary"
                                icon={<SyncOutlined />}
                                onClick={() => {
                                    Modal.confirm({
                                        title: '確認操作',
                                        content: (
                                            <div>
                                                確認同步現行圖文選單資料嗎？<br />
                                            </div>
                                        ),
                                        okText: '確認',
                                        cancelText: '取消',
                                        onOk() {
                                            return httpHandler.get(`/toyota_mgmt/richmenu_maintenance/sync_current_menu`).then((response) => {
                                                if (response.success) {
                                                    window.antdNotify('同步成功', response.message, 'success');
                                                    searchRichmenuData();
                                                } else {
                                                    window.antdNotify('同步錯誤', response.message, 'fail');
                                                }
                                            });
                                        },
                                        onCancel() {
                                            console.log('取消操作');
                                        },
                                    });
                                }}
                                className="button button--register">
                                同步現行選單
                            </Button>
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={() => {
                                    setIsEditVisible(true);
                                    setSelectedRow(null);
                                    setLayoutCount(1);
                                    setImageLoading(true);
                                    // document.getElementById('editBlockform').scrollIntoView({ behavior: 'smooth' });
                                }}
                                className="button button--register">
                                新增
                            </Button>
                            <Button
                                type="primary"
                                icon={<SearchOutlined />}
                                htmlType="submit"
                                className="button button--search">
                                搜尋
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </>
        );
    };


    // 表格組件
    const DataTable = ({ parentData }) => {

        let columns = [
            {
                title: "操作",
                dataIndex: "operation",
                render: (text, record) => (
                    <div>
                        <Button
                            icon={<EditOutlined />}
                            type="primary"
                            className="button--edit"
                            onClick={() => {
                                handleEdit(record);
                                // document.getElementById('editBlockform').scrollIntoView({ behavior: 'smooth' });
                                setIsSelectedRowPic(true);
                            }}
                            style={{ margin: 4 }}
                        >
                            編輯
                        </Button>
                        <Button
                            icon={<RocketOutlined />}
                            type="primary"
                            className="button--edit button--enable"
                            onClick={() => { handleStatusChange(record, 'enable') }}
                            style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', margin: 4 }}
                            disabled={!record.is_cancel}
                        >
                            啟用
                        </Button>
                        {/* <Button
                            icon={<DeleteOutlined />}
                            type="danger"
                            className="button--delete"
                            onClick={() => handleStatusChange(record, 'disable')}
                            style={{ margin: 4 }}
                        >
                            停用
                        </Button> */}
                    </div>
                ),
            },
            {
                title: "選單名稱",
                dataIndex: "name",
            },
            {
                title: "選單分類",
                dataIndex: "category",
                render: (text, record) => {
                    return richmenuTypeMap[record.category] || "未知分類";
                }
            },
            {
                title: "選單佈局",
                dataIndex: "layout",
                render: (text) => {
                    if (text === 1) return "單一佈局";
                    if (text === 2) return "雙宮格佈局";
                    if (text === 3) return "三宮格佈局";
                    if (text === 6) return "六宮格佈局";
                    if (text === 9) return "九宮格佈局";
                    return "未知佈局";
                }
            },
            {
                title: "是否啟用",
                dataIndex: "is_cancel",
                key: "is_cancel",
                render: (text) => {
                    if (text === 0) return "是";
                    if (text === 1) return "否";
                    return "全部";
                },
            },
            // {
            //     title: "啟用時間",
            //     dataIndex: "start_time",
            //     render: (text) => {
            //         return text ? dayjs(text).format("YYYY-MM-DD HH:mm:ss") : "";
            //     }
            // }
        ].filter((item) => !item.hidden);

        const handleEdit = async (record) => {
            // 編輯按鈕的處理邏輯
            editBlockform.resetFields();
            setSelectedRow(record);
            setIsEditVisible(true);
            const imageData = await getRichmenuImage(record);
            setSelectedRowPic(imageData);
            for (let i = 0; i < 6; i++) {
                const blockType = record[`block${i + 1}_type`];
                updateBlockType(i.toString(), blockType);
            }
        };

        const getRichmenuImage = async (record) => {
            try {
                const encodedUri = encodeURIComponent(record.menu_pic_uri);
                const response = await httpHandler.get(`/toyota_mgmt/richmenu_maintenance/get_richmenu_image?menu_pic_uri=${encodedUri}`);
                const fileExtend = record.menu_pic_uri.split('.').pop();
                if (response.success) {
                    return `data:image/${fileExtend};base64,${response.data}`;
                } else {
                    window.antdNotify('錯誤', response.message, 'fail');
                    return null;
                }
            } catch (error) {
                console.error(error);
                return null;
            }
        };

        const handleStatusChange = (record, action) => {

            let status
            if (action === 'disable') {
                status = "1";
            } else if (action === 'enable') {
                status = "0";
            }
            const postData = {
                richmenu_name: record.name,
                is_cancel: status,
                category: record.category,
            }
            const statusString = status === "0" ? '啟用' : '停用';

            Modal.confirm({
                title: '確認操作',
                content: (
                    <div>
                        確定啟用當前圖文選單?<br />
                        啟用後會上傳圖文選單至 LINE OA <br />
                        並且覆蓋同類型({richmenuTypeMap[record.category]})原有圖文選單
                    </div>
                ),
                okText: '確認',
                cancelText: '取消',
                onOk() {
                    return httpHandler.post(`/toyota_mgmt/richmenu_maintenance/richmenu_status`, postData).then((response) => {
                        if (response.data.success) {
                            window.antdNotify('成功', response.message, 'success');
                            searchRichmenuData();
                        } else {
                            window.antdNotify('錯誤', response.message, 'fail');
                        }
                    });
                },
                onCancel() {
                    console.log('取消操作');
                },
            });

        }


        return (
            <>
                <Table
                    columns={columns}
                    rowKey={(row) => row.TBID}
                    dataSource={tableData}
                    pagination={tableParams.pagination}
                    loading={loading}
                    bordered="true"
                    showHeader={true}
                    footer={() => <></>}
                    onChange={handleTableChange}
                />

            </>
        );
    };

    useEffect(() => {
        if (selectedRow && selectedRow.layout > 0) {
            setLayoutCount(selectedRow.layout);
            editBlockform.setFieldsValue({
                name: selectedRow.name,
                category: selectedRow.category,
                layout: selectedRow.layout,
                startTime: dayjs(selectedRow.start_time)
            });
            const fieldsValue = {};
            for (let i = 0; i < layoutCount; i++) {
                fieldsValue[`block${i + 1}_name`] = selectedRow[`block${i + 1}_name`];
                fieldsValue[`block${i + 1}_type`] = selectedRow[`block${i + 1}_type`];
                fieldsValue[`block${i + 1}_action`] = selectedRow[`block${i + 1}_action`];
                fieldsValue[`block${i + 1}_tag`] = selectedRow[`block${i + 1}_tag`];
                fieldsValue[`block${i + 1}_`] = selectedRow[`block${i + 1}_tag`];
                fieldsValue[`block${i + 1}_display_text`] = selectedRow[`block${i + 1}_display_text`];
            }
            editBlockform.setFieldsValue(fieldsValue);

            if (!selectedRow.menu_pic_uri) {
                setImageLoading(true);
            } else {
                setImageLoading(false);
            }
        } else if (selectedRow === null) {
            editBlockform.setFieldsValue({
                name: null,
                category: null,
                layout: null
            });
            for (let i = 0; i < layoutCount; i++) {
                editBlockform.setFieldsValue({
                    [`block${i + 1}_name`]: null,
                    [`block${i + 1}_type`]: null,
                    [`block${i + 1}_action`]: null,
                    [`block${i + 1}_tag`]: null,
                    [`block${i + 1}_display_text`]: null
                });
            }
        }

    }, [selectedRow]);

    const DynamicForm = ({ selectedRow, i, blockKeyword }) => {
        return (
            <div>
                {totalBlockType[`${i}`] === "0" ? (
                    <Form.Item
                        key={`block${i + 1}_action`}
                        label={`區塊 ${i + 1} 關鍵字/URI`}
                        name={`block${i + 1}_action`}
                        initialValue={blockKeyword}
                    >
                        <Select placeholder={`選擇區塊 ${i + 1} 功能`}>
                            {['customer-service', 'secretary', 'appointment', 'advice', 'owner-benefit',].map((option, index) => (
                                <Option key={index} value={`action=${option}`}>
                                    {`action=${option}`}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                ) : (
                    <Form.Item
                        key={`block${i + 1}_action`}
                        label={`區塊 ${i + 1} 關鍵字/URI`}
                        name={`block${i + 1}_action`}
                        initialValue={blockKeyword}
                    >
                        <Input placeholder={`輸入區塊 ${i + 1} 關鍵字/URI`} />
                    </Form.Item>
                )}
            </div>
        )
    }

    const RichmenuEditBlock = ({ selectedRow }) => {



        const renderDynamicSelects = () => {

            const selects = [];
            for (let i = 0; i < layoutCount; i++) {
                const blockName = selectedRow ? selectedRow[`block${i + 1}_name`] : '';
                const blockType = selectedRow ? selectedRow[`block${i + 1}_type`] : '';
                const blockKeyword = selectedRow ? selectedRow[`block${i + 1}_action`] : '';
                const blockTag = selectedRow ? selectedRow[`block${i + 1}_tag`] : '';
                const blockDisplayText = selectedRow ? selectedRow[`block${i + 1}_display_text`] : '';
                selects.push(
                    <Col span={8} key={i}>
                        <div style={{ border: '2px solid #C7C7C7', padding: '10px', marginBottom: '10px' }}>
                            <Form.Item
                                key={`block${i}_name`}
                                label={`區塊 ${i + 1} 名稱`}
                                name={`block${i + 1}_name`}
                                initialValue={blockName}
                                rules={[{ required: true, message: '請輸入名稱' }]}
                            >
                                <Input placeholder={`輸入區塊 ${i + 1} 名稱`} />
                            </Form.Item>
                            <Form.Item
                                key={`block${i + 1}_type`}
                                label={`區塊 ${i + 1} 類型`}
                                name={`block${i + 1}_type`}
                                initialValue={blockType}
                            >
                                <Select placeholder={`區塊 ${i + 1} 類型`} onChange={value => updateBlockType(`${i}`, value)}>
                                    <Option value="0">系統默認功能</Option>
                                    <Option value="1">URI 轉跳</Option>
                                    {selectedRow && selectedRow[`block${i + 1}_action`] && Array.isArray(selectedRow[`block${i + 1}_action`]) && selectedRow[`block${i + 1}_action`].map((option, index) => (
                                        <Option key={index} value={option.value}>
                                            {option.label}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            {DynamicForm({ selectedRow, i, blockKeyword })}
                            <Form.Item
                                key={`block${i + 1}_tag`}
                                label={`區塊 ${i + 1} 標籤`}
                                name={`block${i + 1}_tag`}
                                initialValue={blockTag}
                            >
                                <Input placeholder={`輸入區塊 ${i + 1} 標籤`} />
                            </Form.Item>
                            <Form.Item
                                key={`block${i + 1}_display_text`}
                                label={`區塊 ${i + 1} 聊天室顯示文字`}
                                name={`block${i + 1}_display_text`}
                                initialValue={blockDisplayText}
                            >
                                <Input placeholder={`輸入區塊 ${i + 1} 聊天室顯示文字`} />
                            </Form.Item>
                        </div>
                    </Col>
                );

            }
            return <Row gutter={16}>{selects}</Row>;
        };

        return (
            <div id="editBlockform">
                <Modal
                    title="圖文選單編輯"
                    visible={isEditVisible}
                    width="80%"
                    onCancel={() => {
                        setIsEditVisible(false);
                        setSelectedRow(null);
                        setImageLoading(true);
                        setSelectedRowPic(null);
                        setIsSelectedRowPic(false);
                        editBlockform.resetFields();
                        setPreviewVisible(false);
                        setFileList([]);
                    }
                    }
                    footer={null}
                >
                    {!isEditVisible && <Table bordered="true"></Table>}
                    {isEditVisible && (
                        <Form
                            form={editBlockform}
                            layout="vertical"
                        // onFinish={handleFormSubmit}
                        >
                            <Row gutter={16}>
                                <Col span={16}>
                                    <Form.Item
                                        label="圖文選單圖片"
                                        style={{ border: '1px solid #d9d9d9', padding: '16px', backgroundColor: '#fafafa', borderRadius: '10px' }}
                                        name="menu_pic"
                                    >
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', maxHeight: '400px', overflow: 'hidden' }}>
                                            {previewVisible && (
                                                <div style={{
                                                    backgroundColor: 'f0f0f0',
                                                    height: '100%',
                                                    aspectRatio: '2500 / 1686',
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    marginTop: '16px'
                                                }}>
                                                    <Image
                                                        src={previewImage}
                                                        alt="Upload Image"
                                                        onLoad={() => setImageLoading(false)}
                                                        style={{
                                                            // width: '100%',
                                                            height: '100%',
                                                        }}
                                                    />
                                                </div>
                                            )}
                                            {imageLoading && (
                                                <div style={{
                                                    backgroundColor: 'f0f0f0',
                                                    width: '100%',
                                                    aspectRatio: '2500 / 1686',
                                                    position: 'relative',
                                                    overflow: 'hidden'
                                                }}>
                                                    <Skeleton.Image style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover'
                                                    }} />
                                                </div>
                                            )}
                                            {isSelectedRowPic && (
                                                <div style={{
                                                    backgroundColor: 'f0f0f0',
                                                    height: '100%',
                                                    aspectRatio: '2500 / 1686',
                                                    position: 'relative',
                                                    overflow: 'hidden'
                                                }}>
                                                    <Image
                                                        src={selectedRowPic}
                                                        alt="Selected Image"
                                                        onLoad={() => setImageLoading(false)}
                                                        style={{
                                                            aspectRatio: '2500 / 1686',
                                                        }}
                                                    />
                                                </div>
                                            )}
                                            <div style={{ marginTop: '16px' }}>
                                                <Upload
                                                    name="menuImage"
                                                    fileList={fileList}
                                                    beforeUpload={beforeUpload}
                                                    onChange={handleUploadChange}
                                                    onPreview={handlePreview}
                                                    maxCount={1}
                                                    onRemove={handleRemove}
                                                >
                                                    <Button type="primary" icon={<UploadOutlined />} style={{ marginRight: '8px' }}>
                                                        上傳圖片
                                                    </Button>
                                                </Upload>
                                            </div>
                                        </div>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item label="選單名稱" name="name">
                                        <Input placeholder="輸入選單名稱" />
                                    </Form.Item>
                                    <Form.Item label="選單分類" name="category">
                                        <Select placeholder="選單分類" >
                                            <Option value={1}>車主服務-未綁定</Option>
                                            <Option value={2}>探索車款-未綁定</Option>
                                            <Option value={3}>車主活動-未綁定</Option>
                                            <Option value={4}>車主服務-已綁定</Option>
                                            <Option value={5}>探索車款-已綁定</Option>
                                            <Option value={6}>車主活動-已綁定</Option>
                                        </Select>
                                    </Form.Item>
                                    <Form.Item label="當前佈局" name="layout">
                                        <Select placeholder="選擇佈局" value={layoutCount} onChange={value => setLayoutCount(value)}>
                                            <Option value={1}>單一佈局</Option>
                                            <Option value={6}>六宮格佈局</Option>
                                            {selectedRow && selectedRow.layouts && Array.isArray(selectedRow.layouts) && selectedRow.layouts.map((layout, index) => (
                                                <Option key={index} value={layout.value}>
                                                    {layout.label}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                    {/* <Form.Item label="啟用時間" name="startTime">
                                    <DatePicker showTime style={{ width: '100%' }} />
                                </Form.Item> */}
                                    <Form.Item style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>

                                        {selectedRow && selectedRow.is_cancel ? (
                                            <Button
                                                type="primary"
                                                htmlType="submit"
                                                onClick={() => {
                                                    setSubmitActionType('update');
                                                    setSubmitFormData(editBlockform.getFieldsValue());
                                                    setIsModalVisible(true);
                                                }}
                                                style={{ margin: 4 }}
                                            >
                                                更新當前選單
                                            </Button>
                                        ) : (
                                            <Button
                                                type="primary"
                                                htmlType="submit"
                                                onClick={() => {
                                                    setSubmitActionType('create');
                                                    setSubmitFormData(editBlockform.getFieldsValue());
                                                    setIsModalVisible(true);
                                                }}
                                                style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', margin: 4 }}
                                            >
                                                另存為新選單
                                            </Button>
                                        )}
                                        <Button
                                            icon={<DeleteOutlined />}
                                            type="danger"
                                            className="button--delete"
                                            onClick={() => {
                                                Modal.confirm({
                                                    title: '確認操作',
                                                    content: (
                                                        <div>
                                                            確定清除當前修改？<br />
                                                            (此操作不會影響目前選單內容)
                                                        </div>
                                                    ),
                                                    okText: '確認',
                                                    cancelText: '取消',
                                                    onOk() {
                                                        setSelectedRow(null);
                                                        setImageLoading(true);
                                                        setSelectedRowPic(null);
                                                        setIsSelectedRowPic(false);
                                                        editBlockform.resetFields();
                                                        setPreviewVisible(false);
                                                        setFileList([]);
                                                    },
                                                    onCancel() {
                                                        console.log('取消操作');
                                                    },
                                                });
                                            }}
                                            style={{ margin: 4 }}
                                        >
                                            清除
                                        </Button>
                                    </Form.Item>
                                </Col>
                            </Row>

                            {renderDynamicSelects()}

                        </Form>

                    )
                    }

                </Modal>

            </div >

        );
    };

    const handleUploadChange = ({ fileList }) => {
        setFileList(fileList);

        // 檢查文件是否上傳完成
        fileList.forEach(file => {
            handlePreview(file);
        });

        isSelectedRowPic && setIsSelectedRowPic(false);
    };

    // 上傳前檢查
    const beforeUpload = (file) => {
        // 檢查檔案類型

        const isImage = file.type.startsWith('image/');
        if (!isImage) {
            window.antdNotify('錯誤', '只能上傳圖片檔案', 'fail');
            return Upload.LIST_IGNORE;
        }
        // 檢查檔案大小
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
            window.antdNotify('錯誤', '圖片大小不能超過10MB', 'fail');
            return Upload.LIST_IGNORE;
        }
        return false;
    };
    // 上傳圖片轉base64
    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };
    // 預覽圖片
    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewTitle(file.name);
        setPreviewImage(file.preview);
        setPreviewVisible(true);
    };

    const handleRemove = () => {
        setPreviewVisible(false)
        setImageLoading(true)
        setPreviewImage('')
    }

    const transformFormData = (formData) => {

        const transformedData = {
            name: formData.name,
            layout: formData.layout,
            block1_name: formData.block1_name ? formData.block1_name : '',
            block1_action: formData.block1_action ? formData.block1_action : '',
            block1_tag: formData.block1_tag ? formData.block1_tag : '',
            block1_type: formData.block1_type ? formData.block1_type : '',
            block2_name: formData.block2_name ? formData.block2_name : '',
            block2_action: formData.block2_action ? formData.block2_action : '',
            block2_tag: formData.block2_tag ? formData.block2_tag : '',
            block2_type: formData.block2_type ? formData.block2_type : '',
            block3_name: formData.block3_name ? formData.block3_name : '',
            block3_action: formData.block3_action ? formData.block3_action : '',
            block3_tag: formData.block3_tag ? formData.block3_tag : '',
            block3_type: formData.block3_type ? formData.block3_type : '',
            block4_name: formData.block4_name ? formData.block4_name : '',
            block4_action: formData.block4_action ? formData.block4_action : '',
            block4_tag: formData.block4_tag ? formData.block4_tag : '',
            block4_type: formData.block4_type ? formData.block4_type : '',
            block5_name: formData.block5_name ? formData.block5_name : '',
            block5_action: formData.block5_action ? formData.block5_action : '',
            block5_tag: formData.block5_tag ? formData.block5_tag : '',
            block5_type: formData.block5_type ? formData.block5_type : '',
            block6_name: formData.block6_name ? formData.block6_name : '',
            block6_action: formData.block6_action ? formData.block6_action : '',
            block6_tag: formData.block6_tag ? formData.block6_tag : '',
            block6_type: formData.block6_type ? formData.block6_type : '',
            block7_name: formData.block7_name ? formData.block7_name : '',
            block7_action: formData.block7_action ? formData.block7_action : '',
            block7_tag: formData.block7_tag ? formData.block7_tag : '',
            block7_type: formData.block7_type ? formData.block7_type : '',
            block8_name: formData.block8_name ? formData.block8_name : '',
            block8_action: formData.block8_action ? formData.block8_action : '',
            block8_tag: formData.block8_tag ? formData.block8_tag : '',
            block8_type: formData.block8_type ? formData.block8_type : '',
            block9_name: formData.block9_name ? formData.block9_name : '',
            block9_action: formData.block9_action ? formData.block9_action : '',
            block9_tag: formData.block9_tag ? formData.block9_tag : '',
            block9_type: formData.block9_type ? formData.block9_type : '',
            block1_display_text: formData.block1_display_text ? formData.block1_display_text : '',
            block2_display_text: formData.block2_display_text ? formData.block2_display_text : '',
            block3_display_text: formData.block3_display_text ? formData.block3_display_text : '',
            block4_display_text: formData.block4_display_text ? formData.block4_display_text : '',
            block5_display_text: formData.block5_display_text ? formData.block5_display_text : '',
            block6_display_text: formData.block6_display_text ? formData.block6_display_text : '',
            block7_display_text: formData.block7_display_text ? formData.block7_display_text : '',
            block8_display_text: formData.block8_display_text ? formData.block8_display_text : '',
            block9_display_text: formData.block9_display_text ? formData.block9_display_text : '',
            menu_pic: previewImage,
            is_cancel: 1,

            start_time: formData.startTime ? dayjs(formData.startTime).format('YYYY-MM-DD HH:mm:ss') : '',
            category: formData.category,
        };

        if (submitActionType === 'create') {
            transformedData.create_user = secureStorage.getItem('userId');
            transformedData.create_time = moment().format('YYYY-MM-DD HH:mm:ss');
        } else if (submitActionType === 'update') {
            transformedData.update_user = secureStorage.getItem('userId');
            transformedData.update_time = moment().format('YYYY-MM-DD HH:mm:ss');
        }
        return transformedData;
    };

    // 更新＆新增圖文選單
    const handleSubmit = () => {
        editBlockform.validateFields()
            .then(values => {


                const insertData = transformFormData(values);
                if (values.menu_pic === undefined || values.menu_pic === null || values.menu_pic === '') {
                    insertData.menu_pic = selectedRow.menu_pic_uri;
                }

                if (submitActionType === 'create') {
                    httpHandler.post('/toyota_mgmt/richmenu_maintenance/insert_new_richmenu', insertData).then((response) => {
                        if (response.success) {
                            window.antdNotify('成功新增圖文選單', response.message, 'success');
                            setIsModalVisible(false);
                            setSelectedRow(null);
                            setIsEditVisible(false);
                            setPreviewVisible(false);
                            setFileList([]);
                        } else {
                            window.antdNotify('錯誤', response.message, 'fail');
                        }
                    }
                    )
                } else if (submitActionType === 'update') {

                    httpHandler.put(`/toyota_mgmt/richmenu_maintenance/News/${values.name}`, insertData).then((response) => {
                        if (response.success) {
                            window.antdNotify('成功更新圖文選單', response.message, 'success');
                            setIsModalVisible(false);
                            setSelectedRow(null);
                            setIsEditVisible(false);
                            setPreviewVisible(false);
                            setFileList([]);
                        } else {
                            window.antdNotify('錯誤', response.message, 'fail');
                        }
                    }
                    )
                }
                setIsModalVisible(false);
                setLoading(true);
                searchRichmenuData();
            })
            .catch(errorInfo => {
                // console.log('表單驗證失敗:', errorInfo);
                window.antdNotify('資料驗證失敗', "請確認資料是否完整", 'fail');
            })
    };

    // 確認執行 Modal
    const RichmenuMaintenanceModal = () => {
        const formData = editBlockform.getFieldsValue();
        return (
            <Modal
                title={<div style={{ textAlign: 'center', width: '100%' }}>確認執行？</div>}
                visible={isModalVisible}
                onCancel={() => {
                    setIsModalVisible(false);
                }}
                footer={[
                    <Button key="cancel" onClick={() => {
                        setIsModalVisible(false);
                    }}>
                        取消
                    </Button>,
                    <Button key="submit"
                        onClick={handleSubmit}
                        type="primary"
                    >
                        確認
                    </Button>
                ]}
                width={1000}
            >
                {formData ? (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                        <p>圖文選單名稱: {formData.name}</p>
                        <p>圖文選單分類: {richmenuTypeMap[formData.category]}</p>
                        <p>圖文選單佈局: {formData.layout}</p>
                        {/* <p>圖文選單啟用時間: {formData.startTime ? dayjs(formData.startTime).format('YYYY-MM-DD HH:mm:ss') : ''}</p> */}
                    </div>
                ) : (
                    <p>沒有選擇任何資料</p>
                )}
            </Modal>
        );
    };

    const RichmenuCombinedComponent = ({ selectedRow, loading }) => {
        return (
            <div>
                <RichmenuEditBlock selectedRow={selectedRow} />
                <RichmenuMaintenanceModal selectedRow={selectedRow} />
            </div>
        );
    };

    const section = [
        {
            hasTitle: false,
            title: 'Search',
            children: <SearchBar />,
        },
        {
            hasTitle: false,
            title: 'Data',
            children: loading ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <Spin tip="Loading..." size="large" />
            </div> : <DataTable />,
        },
        {
            hasTitle: false,
            title: 'Edit and Modal',
            children: <RichmenuCombinedComponent selectedRow={selectedRow} loading={loading} />,
        },
    ]

    return (
        <div>
            <PageHeader functionName={'toyota_richmenu'}></PageHeader>
            <PageBody section={section}></PageBody>
        </div>
    );
};

export default RichmenuMaintenance;